import {selectDomain} from '.';
import {PaginationMeta} from '../types';
import {createSelector} from '@reduxjs/toolkit';

export default <ExtraMetaData = {}>(name: string) =>
  createSelector(selectDomain, domain => {
    return domain.meta[name] as PaginationMeta & ExtraMetaData;
  });
